import * as TYPES from './_store/types';
export function asyncData(store) {
    
    let ps = [];
    if (this.listingDetail.hjId) {
        ps.push(
            store[TYPES.FETCH_ORIGIN_DEMOGRAPHICS](this.listingDetail.hjId)
        );
    }
    return Promise.all(ps)
}
